import BaseModel from './BaseModel'

export default class companyPhonenumber extends BaseModel {
  static entity = 'companies_phonenumbers'

  static primaryKey = ['company_id', 'phonenumber_id']

  static fields() {
    return {
      company_id: this.attr(null),
      phonenumber_id: this.attr(null),
    }
  }

  static methodConf = {
    methods: {
      $delete: {
        name: 'delete',
        http: {
          url: '/:company_id/:phonenumber_id/',
          method: 'delete',
        },
      },
    },
  }
}
